export const LEFT_ARROW = {
   start: 'left+=48px left',
   scroller: '.tabScrollbar',
   end: 'left+=80px left',
   tweenTo: { autoAlpha: 1 },
   tweenFrom: { autoAlpha: 0 }
};

export const RIGHT_ARROW = {
   start: 'right-=80px right',
   scroller: '.tabScrollbar',
   end: 'right-=48px right',
   tweenTo: { autoAlpha: 0 },
   tweenFrom: { autoAlpha: 1 }
};
